/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ContentBlock from '../components/ContentBlock';
import PageActivationCompte from '../components/PageActivationCompte';
import PageActiviteConseil from '../components/PageActiviteConseil';
import PageArticle from '../components/PageArticle';
import PageBrands from '../components/PageBrands';
import PageChallengeBeneficiaires from '../components/PageChallengeBeneficiaires';
import PageChallengeDetail from '../components/PageChallengeDetail';
import PageChallenges from '../components/PageChallenges';
import PageConcoursHome from '../components/PageConcoursHome';
import PageContact from '../components/PageContact';
import PageContactConnect from '../components/PageContactConnect';
import PageContent from '../components/PageContent';
import PageError from '../components/PageError';
import PageEventBirthDay from '../components/PageEventBirthDay';
import PageEventDetail from '../components/PageEventDetail';
import PageEventMyMembers from '../components/PageEventMyMembers';
import PageEventMyRegistrations from '../components/PageEventMyRegistrations';
import PageEvents from '../components/PageEvents';
import PageFAQ from '../components/PageFAQ';
import PageFormationFavorites from '../components/PageFormationFavorites';
import PageHome from '../components/PageHome';
import PageIndex from '../components/PageIndex';
import PageInfoPerso from '../components/PageInfoPerso';
import PageIngredient from '../components/PageIngredient';
import PageIngredientList from '../components/PageIngredientList';
import PageListe from '../components/PageListe';
import PageListeFacebookPOST from '../components/PageListeFacebookPOST';
import PageMentionContent from '../components/PageMentionContent';
import PageMesPresences from '../components/PageMesPresences';
import PageNouveauCompte from '../components/PageNouveauCompte';
import PagePhotoContest from '../components/PagePhotoContest';
import PageProduct from '../components/PageProduct';
import PageProductSegments from '../components/PageProductSegments';
import PageRanges from '../components/PageRanges';
import PageRecherche from '../components/PageRecherche';
import PageResultContest from '../components/PageResultContest';
import PageSegments from '../components/PageSegments';
import ProductRanges from '../components/ProductRanges';
import ProductSegmentRoutines from '../components/ProductSegmentRoutines';
import SectionBadgeElite from '../components/SectionBadgeElite';
import SectionContest from '../components/SectionContest';
import SectionProductCarousel from '../components/SectionProductCarousel';
import SectionPushArticle from '../components/SectionPushArticle';
import SectionWideCarousel from '../components/SectionWideCarousel';
import GetCurrentArticleReviews from '..//components/AllPages/GraphQL/GetCurrentArticleReviews.js';
import MainFooter from '..//components/AllPages/MainFooter.js';
import MainFooterLogin from '..//components/AllPages/MainFooterLogin.js';
import MainHeader from '..//components/AllPages/MainHeader.js';
import MainHeaderLogin from '..//components/AllPages/MainHeaderLogin.js';
import MainMeta from '..//components/AllPages/MainMeta.js';
import ObjBackToTop from '..//components/AllPages/ObjBackToTop.js';
import ObjBigTitle from '..//components/AllPages/ObjBigTitle.js';
import ObjBreadcrumb from '..//components/AllPages/ObjBreadcrumb.js';
import ObjDescription from '..//components/AllPages/ObjDescription.js';
import ObjHeaderSearch from '..//components/AllPages/ObjHeaderSearch.js';
import ObjPushArticle from '..//components/AllPages/ObjPushArticle.js';
import ObjPushCustomFull from '..//components/AllPages/ObjPushCustomFull.js';
import ObjPushCustomThumb from '..//components/AllPages/ObjPushCustomThumb.js';
import ObjPushParcours from '..//components/AllPages/ObjPushParcours.js';
import ObjTitle from '..//components/AllPages/ObjTitle.js';
import SectionComments from '..//components/AllPages/SectionComments.js';
import ExpiredConfirmationLink from '..//components/Connexion/ExpiredConfirmationLink.js';
import Inscription from '..//components/Connexion/Inscription.js';
import Login from '..//components/Connexion/Login.js';
import MotDePasse from '..//components/Connexion/MotDePasse.js';
import NouveauCompte from '..//components/Connexion/NouveauCompte.js';
import NouveauMotDePasse from '..//components/Connexion/NouveauMotDePasse.js';
import PageUpdateEmailConfirm from '..//components/Connexion/PageUpdateEmailConfirm.js';
import CustomSelect from '..//components/inc/FormElements/CustomSelect.js';
import FilterInput from '..//components/inc/FormElements/FilterInput.js';
import MultipleFileUpload from '..//components/inc/FormElements/MultipleFileUpload.js';
import PasswordToggle from '..//components/inc/FormElements/PasswordToggle.js';
import SingleFileUpload from '..//components/inc/FormElements/SingleFileUpload.js';
import SingleFileUploadModal from '..//components/inc/FormElements/SingleFileUploadModal.js';
import CommentImageModal from '..//components/inc/Modal/CommentImageModal.js';
import DefaultModal from '..//components/inc/Modal/DefaultModal.js';
import ExpertiseBadgeModal from '..//components/inc/Modal/ExpertiseBadgeModal.js';
import ExpertModal from '..//components/inc/Modal/ExpertModal.js';
import FacebookPostModal from '..//components/inc/Modal/FacebookPostModal.js';
import GalerieDetailModal from '..//components/inc/Modal/GalerieDetailModal.js';
import GalerieUploadModal from '..//components/inc/Modal/GalerieUploadModal.js';
import LoginCodeModal from '..//components/inc/Modal/LoginCodeModal.js';
import ModalAjoutBeneficiaire from '..//components/inc/Modal/ModalAjoutBeneficiaire.js';
import ModalEspaceExclu from '..//components/inc/Modal/ModalEspaceExclu.js';
import ModalEventSession from '..//components/inc/Modal/ModalEventSession.js';
import ModalFormationsFav from '..//components/inc/Modal/ModalFormationsFav.js';
import ModalInfosMandatory from '..//components/inc/Modal/ModalInfosMandatory.js';
import ModalMAJFormationsFav from '..//components/inc/Modal/ModalMAJFormationsFav.js';
import ModalPhoneMandatory from '..//components/inc/Modal/ModalPhoneMandatory.js';
import ModalProduitConcernes from '..//components/inc/Modal/ModalProduitConcernes.js';
import VideoModal from '..//components/inc/Modal/VideoModal.js';
import VideoModalNoFS from '..//components/inc/Modal/VideoModalNoFS.js';
import VideoModalShorts from '..//components/inc/Modal/VideoModalShorts.js';
import ObjAGagnerHomeFormation from '..//components/inc/ObjAGagnerHomeFormation.js';
import ObjALaUneHomeFormation from '..//components/inc/ObjALaUneHomeFormation.js';
import ObjAsideSliderBanner from '..//components/inc/ObjAsideSliderBanner.js';
import ObjBannerHeroComptoirDermato from '..//components/inc/ObjBannerHeroComptoirDermato.js';
import ObjBrandEvent from '..//components/inc/ObjBrandEvent.js';
import ObjCanvasBadgeExpertise from '..//components/inc/ObjCanvasBadgeExpertise.js';
import ObjChallengeDetail from '..//components/inc/ObjChallengeDetail.js';
import ObjChallengeGainLevel from '..//components/inc/ObjChallengeGainLevel.js';
import ObjChallengeGainLevelVentes from '..//components/inc/ObjChallengeGainLevelVentes.js';
import ObjConditionChallenge from '..//components/inc/ObjConditionChallenge.js';
import ObjContinuerLectureHomeComptoirDermato from '..//components/inc/ObjContinuerLectureHomeComptoirDermato.js';
import ObjDerniersAjoutsAside from '..//components/inc/ObjDerniersAjoutsAside.js';
import ObjDirectComptoirDermato from '..//components/inc/ObjDirectComptoirDermato.js';
import ObjEssentielMinuteComptoirDermato from '..//components/inc/ObjEssentielMinuteComptoirDermato.js';
import ObjEventDetail from '..//components/inc/ObjEventDetail.js';
import ObjExpertiseBadge from '..//components/inc/ObjExpertiseBadge.js';
import ObjExpertiseBrand from '..//components/inc/ObjExpertiseBrand.js';
import ObjExpertisePointsAside from '..//components/inc/ObjExpertisePointsAside.js';
import ObjFavoriteFormationAside from '..//components/inc/ObjFavoriteFormationAside.js';
import ObjListPushsThematiqueComptoirDermato from '..//components/inc/ObjListPushsThematiqueComptoirDermato.js';
import ObjListPushsThematiqueFormation from '..//components/inc/ObjListPushsThematiqueFormation.js';
import ObjMenuThematiqueAside from '..//components/inc/ObjMenuThematiqueAside.js';
import ObjMesFormationsFiltre from '..//components/inc/ObjMesFormationsFiltre.js';
import ObjMonParcoursFormation from '..//components/inc/ObjMonParcoursFormation.js';
import ObjNoticeAppMobile from '..//components/inc/ObjNoticeAppMobile.js';
import ObjOutilsDownloadComptoirDermato from '..//components/inc/ObjOutilsDownloadComptoirDermato.js';
import ObjParcours from '..//components/inc/ObjParcours.js';
import ObjParcoursPersoHomeComptoirDermato from '..//components/inc/ObjParcoursPersoHomeComptoirDermato.js';
import ObjProductsRelatedAside from '..//components/inc/ObjProductsRelatedAside.js';
import ObjProduitsAssociesComptoirDermato from '..//components/inc/ObjProduitsAssociesComptoirDermato.js';
import ObjProgressBar from '..//components/inc/ObjProgressBar.js';
import ObjProgressBarExpertise from '..//components/inc/ObjProgressBarExpertise.js';
import ObjPushCardFormation from '..//components/inc/ObjPushCardFormation.js';
import ObjPushChallenge from '..//components/inc/ObjPushChallenge.js';
import ObjPushComptoirDermatoEspaceFormation from '..//components/inc/ObjPushComptoirDermatoEspaceFormation.js';
import ObjPushContactezNousQuestionFormation from '..//components/inc/ObjPushContactezNousQuestionFormation.js';
import ObjPushEventSession from '..//components/inc/ObjPushEventSession.js';
import ObjPushThematiqueFormation from '..//components/inc/ObjPushThematiqueFormation.js';
import ObjRetour from '..//components/inc/ObjRetour.js';
import ObjSectionFormation from '..//components/inc/ObjSectionFormation.js';
import ObjTableauBadgesExpertise from '..//components/inc/ObjTableauBadgesExpertise.js';
import ObjTabsComptoirDermatoFormation from '..//components/inc/ObjTabsComptoirDermatoFormation.js';
import ObjTabsHomeComptoirDermato from '..//components/inc/ObjTabsHomeComptoirDermato.js';
import ObjTabsHomeFormation from '..//components/inc/ObjTabsHomeFormation.js';
import BeforeAfterSlider from '..//components/inc/Plugins/BeforeAfterSlider.js';
import SectionHeroComptoirDermatoCarousel from '..//components/inc/SectionHeroComptoirDermatoCarousel.js';
import SectionHeroFormationCarousel from '..//components/inc/SectionHeroFormationCarousel.js';
import SectionPushContactEtDermato from '..//components/inc/SectionPushContactEtDermato.js';
import SectionSocialsFormationFooter from '..//components/inc/SectionSocialsFormationFooter.js';
import PageBrandAv_Banner from '..//components/PageBrandAv_Banner.js';
import PageBrandAv_Formations from '..//components/PageBrandAv_Formations.js';
import PageBrandAv_Intro from '..//components/PageBrandAv_Intro.js';
import PageBrandAv_TabsSegments from '..//components/PageBrandAv_TabsSegments.js';
import PageBrand_CarrouselBanners from '..//components/PageBrand_CarrouselBanners.js';
import PageBrand_CarrouselsPushs from '..//components/PageBrand_CarrouselsPushs.js';
import PageBrand_TabsFormations from '..//components/PageBrand_TabsFormations.js';
import ModalContentChallengeARepartir from '..//components/PageChallengeDetail/ModalContentChallengeARepartir.js';
import ObjAsideChallengeADeclarer from '..//components/PageChallengeDetail/ObjAsideChallengeADeclarer.js';
import ObjAsideChallengeARepartir from '..//components/PageChallengeDetail/ObjAsideChallengeARepartir.js';
import ObjAsideChallengeVerificationDeclaration from '..//components/PageChallengeDetail/ObjAsideChallengeVerificationDeclaration.js';
import ObjAsideChallengeVerificationRepartition from '..//components/PageChallengeDetail/ObjAsideChallengeVerificationRepartition.js';
import ObjAsideChallengeGains from '..//components/PageChallenges/ObjAsideChallengeGains.js';
import PageFormationsMarque from '..//components/PageFormationsMarque.js';
import SectionBanner2026 from '..//components/PageHome/SectionBanner2026.js';
import SectionHeroHome2026 from '..//components/PageHome/SectionHeroHome2026.js';
import SectionNouveautes2026 from '..//components/PageHome/SectionNouveautes2026.js';
import SectionPushHero2026 from '..//components/PageHome/SectionPushHero2026.js';
import SectionServices2026 from '..//components/PageHome/SectionServices2026.js';
import ObjTabPresences from '..//components/PageMesPresences/ObjTabPresences.js';
import PageMonExpertise from '..//components/PageMonExpertise.js';
import PageNCEventDesinscription from '..//components/PageNCEventDesinscription.js';
import PagePrivilege_Background from '..//components/PagePrivilege_Background.js';
import PageSegment from '..//components/PageSegment.js';
import PageSessionWeb from '..//components/PageSessionWeb.js';
import PageTheme from '..//components/PageTheme.js';
import PageThemeAv from '..//components/PageThemeAv.js';

const components = new Map();
components.set('ContentBlock', ContentBlock);
components.set('PageActivationCompte', PageActivationCompte);
components.set('PageActiviteConseil', PageActiviteConseil);
components.set('PageArticle', PageArticle);
components.set('PageBrands', PageBrands);
components.set('PageChallengeBeneficiaires', PageChallengeBeneficiaires);
components.set('PageChallengeDetail', PageChallengeDetail);
components.set('PageChallenges', PageChallenges);
components.set('PageConcoursHome', PageConcoursHome);
components.set('PageContact', PageContact);
components.set('PageContactConnect', PageContactConnect);
components.set('PageContent', PageContent);
components.set('PageError', PageError);
components.set('PageEventBirthDay', PageEventBirthDay);
components.set('PageEventDetail', PageEventDetail);
components.set('PageEventMyMembers', PageEventMyMembers);
components.set('PageEventMyRegistrations', PageEventMyRegistrations);
components.set('PageEvents', PageEvents);
components.set('PageFAQ', PageFAQ);
components.set('PageFormationFavorites', PageFormationFavorites);
components.set('PageHome', PageHome);
components.set('PageIndex', PageIndex);
components.set('PageInfoPerso', PageInfoPerso);
components.set('PageIngredient', PageIngredient);
components.set('PageIngredientList', PageIngredientList);
components.set('PageListe', PageListe);
components.set('PageListeFacebookPOST', PageListeFacebookPOST);
components.set('PageMentionContent', PageMentionContent);
components.set('PageMesPresences', PageMesPresences);
components.set('PageNouveauCompte', PageNouveauCompte);
components.set('PagePhotoContest', PagePhotoContest);
components.set('PageProduct', PageProduct);
components.set('PageProductSegments', PageProductSegments);
components.set('PageRanges', PageRanges);
components.set('PageRecherche', PageRecherche);
components.set('PageResultContest', PageResultContest);
components.set('PageSegments', PageSegments);
components.set('ProductRanges', ProductRanges);
components.set('ProductSegmentRoutines', ProductSegmentRoutines);
components.set('SectionBadgeElite', SectionBadgeElite);
components.set('SectionContest', SectionContest);
components.set('SectionProductCarousel', SectionProductCarousel);
components.set('SectionPushArticle', SectionPushArticle);
components.set('SectionWideCarousel', SectionWideCarousel);
components.set('GetCurrentArticleReviews', GetCurrentArticleReviews);
components.set('MainFooter', MainFooter);
components.set('MainFooterLogin', MainFooterLogin);
components.set('MainHeader', MainHeader);
components.set('MainHeaderLogin', MainHeaderLogin);
components.set('MainMeta', MainMeta);
components.set('ObjBackToTop', ObjBackToTop);
components.set('ObjBigTitle', ObjBigTitle);
components.set('ObjBreadcrumb', ObjBreadcrumb);
components.set('ObjDescription', ObjDescription);
components.set('ObjHeaderSearch', ObjHeaderSearch);
components.set('ObjPushArticle', ObjPushArticle);
components.set('ObjPushCustomFull', ObjPushCustomFull);
components.set('ObjPushCustomThumb', ObjPushCustomThumb);
components.set('ObjPushParcours', ObjPushParcours);
components.set('ObjTitle', ObjTitle);
components.set('SectionComments', SectionComments);
components.set('ExpiredConfirmationLink', ExpiredConfirmationLink);
components.set('Inscription', Inscription);
components.set('Login', Login);
components.set('MotDePasse', MotDePasse);
components.set('NouveauCompte', NouveauCompte);
components.set('NouveauMotDePasse', NouveauMotDePasse);
components.set('PageUpdateEmailConfirm', PageUpdateEmailConfirm);
components.set('CustomSelect', CustomSelect);
components.set('FilterInput', FilterInput);
components.set('MultipleFileUpload', MultipleFileUpload);
components.set('PasswordToggle', PasswordToggle);
components.set('SingleFileUpload', SingleFileUpload);
components.set('SingleFileUploadModal', SingleFileUploadModal);
components.set('CommentImageModal', CommentImageModal);
components.set('DefaultModal', DefaultModal);
components.set('ExpertiseBadgeModal', ExpertiseBadgeModal);
components.set('ExpertModal', ExpertModal);
components.set('FacebookPostModal', FacebookPostModal);
components.set('GalerieDetailModal', GalerieDetailModal);
components.set('GalerieUploadModal', GalerieUploadModal);
components.set('LoginCodeModal', LoginCodeModal);
components.set('ModalAjoutBeneficiaire', ModalAjoutBeneficiaire);
components.set('ModalEspaceExclu', ModalEspaceExclu);
components.set('ModalEventSession', ModalEventSession);
components.set('ModalFormationsFav', ModalFormationsFav);
components.set('ModalInfosMandatory', ModalInfosMandatory);
components.set('ModalMAJFormationsFav', ModalMAJFormationsFav);
components.set('ModalPhoneMandatory', ModalPhoneMandatory);
components.set('ModalProduitConcernes', ModalProduitConcernes);
components.set('VideoModal', VideoModal);
components.set('VideoModalNoFS', VideoModalNoFS);
components.set('VideoModalShorts', VideoModalShorts);
components.set('ObjAGagnerHomeFormation', ObjAGagnerHomeFormation);
components.set('ObjALaUneHomeFormation', ObjALaUneHomeFormation);
components.set('ObjAsideSliderBanner', ObjAsideSliderBanner);
components.set('ObjBannerHeroComptoirDermato', ObjBannerHeroComptoirDermato);
components.set('ObjBrandEvent', ObjBrandEvent);
components.set('ObjCanvasBadgeExpertise', ObjCanvasBadgeExpertise);
components.set('ObjChallengeDetail', ObjChallengeDetail);
components.set('ObjChallengeGainLevel', ObjChallengeGainLevel);
components.set('ObjChallengeGainLevelVentes', ObjChallengeGainLevelVentes);
components.set('ObjConditionChallenge', ObjConditionChallenge);
components.set('ObjContinuerLectureHomeComptoirDermato', ObjContinuerLectureHomeComptoirDermato);
components.set('ObjDerniersAjoutsAside', ObjDerniersAjoutsAside);
components.set('ObjDirectComptoirDermato', ObjDirectComptoirDermato);
components.set('ObjEssentielMinuteComptoirDermato', ObjEssentielMinuteComptoirDermato);
components.set('ObjEventDetail', ObjEventDetail);
components.set('ObjExpertiseBadge', ObjExpertiseBadge);
components.set('ObjExpertiseBrand', ObjExpertiseBrand);
components.set('ObjExpertisePointsAside', ObjExpertisePointsAside);
components.set('ObjFavoriteFormationAside', ObjFavoriteFormationAside);
components.set('ObjListPushsThematiqueComptoirDermato', ObjListPushsThematiqueComptoirDermato);
components.set('ObjListPushsThematiqueFormation', ObjListPushsThematiqueFormation);
components.set('ObjMenuThematiqueAside', ObjMenuThematiqueAside);
components.set('ObjMesFormationsFiltre', ObjMesFormationsFiltre);
components.set('ObjMonParcoursFormation', ObjMonParcoursFormation);
components.set('ObjNoticeAppMobile', ObjNoticeAppMobile);
components.set('ObjOutilsDownloadComptoirDermato', ObjOutilsDownloadComptoirDermato);
components.set('ObjParcours', ObjParcours);
components.set('ObjParcoursPersoHomeComptoirDermato', ObjParcoursPersoHomeComptoirDermato);
components.set('ObjProductsRelatedAside', ObjProductsRelatedAside);
components.set('ObjProduitsAssociesComptoirDermato', ObjProduitsAssociesComptoirDermato);
components.set('ObjProgressBar', ObjProgressBar);
components.set('ObjProgressBarExpertise', ObjProgressBarExpertise);
components.set('ObjPushCardFormation', ObjPushCardFormation);
components.set('ObjPushChallenge', ObjPushChallenge);
components.set('ObjPushComptoirDermatoEspaceFormation', ObjPushComptoirDermatoEspaceFormation);
components.set('ObjPushContactezNousQuestionFormation', ObjPushContactezNousQuestionFormation);
components.set('ObjPushEventSession', ObjPushEventSession);
components.set('ObjPushThematiqueFormation', ObjPushThematiqueFormation);
components.set('ObjRetour', ObjRetour);
components.set('ObjSectionFormation', ObjSectionFormation);
components.set('ObjTableauBadgesExpertise', ObjTableauBadgesExpertise);
components.set('ObjTabsComptoirDermatoFormation', ObjTabsComptoirDermatoFormation);
components.set('ObjTabsHomeComptoirDermato', ObjTabsHomeComptoirDermato);
components.set('ObjTabsHomeFormation', ObjTabsHomeFormation);
components.set('BeforeAfterSlider', BeforeAfterSlider);
components.set('SectionHeroComptoirDermatoCarousel', SectionHeroComptoirDermatoCarousel);
components.set('SectionHeroFormationCarousel', SectionHeroFormationCarousel);
components.set('SectionPushContactEtDermato', SectionPushContactEtDermato);
components.set('SectionSocialsFormationFooter', SectionSocialsFormationFooter);
components.set('PageBrandAv_Banner', PageBrandAv_Banner);
components.set('PageBrandAv_Formations', PageBrandAv_Formations);
components.set('PageBrandAv_Intro', PageBrandAv_Intro);
components.set('PageBrandAv_TabsSegments', PageBrandAv_TabsSegments);
components.set('PageBrand_CarrouselBanners', PageBrand_CarrouselBanners);
components.set('PageBrand_CarrouselsPushs', PageBrand_CarrouselsPushs);
components.set('PageBrand_TabsFormations', PageBrand_TabsFormations);
components.set('ModalContentChallengeARepartir', ModalContentChallengeARepartir);
components.set('ObjAsideChallengeADeclarer', ObjAsideChallengeADeclarer);
components.set('ObjAsideChallengeARepartir', ObjAsideChallengeARepartir);
components.set('ObjAsideChallengeVerificationDeclaration', ObjAsideChallengeVerificationDeclaration);
components.set('ObjAsideChallengeVerificationRepartition', ObjAsideChallengeVerificationRepartition);
components.set('ObjAsideChallengeGains', ObjAsideChallengeGains);
components.set('PageFormationsMarque', PageFormationsMarque);
components.set('SectionBanner2026', SectionBanner2026);
components.set('SectionHeroHome2026', SectionHeroHome2026);
components.set('SectionNouveautes2026', SectionNouveautes2026);
components.set('SectionPushHero2026', SectionPushHero2026);
components.set('SectionServices2026', SectionServices2026);
components.set('ObjTabPresences', ObjTabPresences);
components.set('PageMonExpertise', PageMonExpertise);
components.set('PageNCEventDesinscription', PageNCEventDesinscription);
components.set('PagePrivilege_Background', PagePrivilege_Background);
components.set('PageSegment', PageSegment);
components.set('PageSessionWeb', PageSessionWeb);
components.set('PageTheme', PageTheme);
components.set('PageThemeAv', PageThemeAv);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
